// Internal Imports
import { GlobalUtils } from "../../utils";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;

export default function OnBoardGating(props) {
  // Fetch on boarding checklist
  const checklist = readDataFromLocalStorage("onBoardCheckList");

  // Check if user has click the onboarding components
  const showOnboardFlag =
    (checklist &&
      Object.prototype.hasOwnProperty.call(checklist, props.name) &&
      checklist[props.name]) ||
    false;

  // * If the value is true, then user have not seen the onboarding action
  if (showOnboardFlag) {
    return props.altComponent;
  }
  // * If user has seen the onboarding action then return the component
  return props.children;
}
